import { render, staticRenderFns } from "./recontentPillow.vue?vue&type=template&id=5bb2bbd5&scoped=true&"
import script from "./recontentPillow.vue?vue&type=script&lang=js&"
export * from "./recontentPillow.vue?vue&type=script&lang=js&"
import style1 from "./recontentPillow.vue?vue&type=style&index=1&id=5bb2bbd5&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb2bbd5",
  null
  
)

export default component.exports